import template from 'text!./templates/report-frame.html';
import _ from 'underscore';
import $ from 'jquery';

export default ['$compile', '$q', '$sce', 'ModalService', 'httpSettings', function ($compile, $q, $sce, ModalService, httpSettings) {
    var matchHeightToContents = function matchHeightToContents(iframe, $target, $scope) {
        var frameBody = void 0;
        var frameWindow = void 0;
        try {
            frameBody = iframe.contentDocument.body;
            frameWindow = window.frames[iframe.name];
        } catch (e) {
            console.error('Unable to adjust height of report frame at %s — its contents are not accessible due to same origin policy', iframe.src);
            return; // Can not access the iframe most probably due to same origin policy
        }

        var resize = function resize() {
            $(iframe).height(frameWindow.outerHeight);
        };

        resize();

        var observer = void 0;
        try {
            observer = new MutationObserver(resize);
        } catch (e) {
            return;
        }

        observer.observe(frameBody, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true
        });

        var disconnect = function disconnect() {
            if (observer) {
                observer.disconnect();
            }
        };
        $scope.$on('$destroy', disconnect);
        $scope.$watch('url', _.after(2, _.once(disconnect))); // Skip initial watch, disconnect once on url changes.
    };

    var loadUrl = function loadUrl($scope, $target) {
        if (!$scope.url) {
            return;
        }

        var loaded = $q.defer();
        $scope.loadingPromise = loaded.promise;

        var loadTimeout = setTimeout(function () {
            loaded.reject();
        }, httpSettings.timeout);

        var markup = $compile(template)($scope);
        var frame = markup.find('iframe').get(0);
        frame.name = String(Math.random());
        frame.src = $sce.trustAsResourceUrl($scope.url);
        frame.onload = function () {
            matchHeightToContents(frame, $target, $scope);
            clearTimeout(loadTimeout);
            loaded.resolve();
        };
        frame.onerror = function () {
            clearTimeout(loadTimeout);
            loaded.reject();
        };
        $target.empty().append(markup);

        loaded.promise.catch(function () {
            $target.empty(); // Remove the frame, it failed to load
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    };

    return {
        restrict: 'E',
        scope: {
            url: '@'
        },
        link: function link($scope, $element) {
            $scope.$watch('url', loadUrl.bind(null, $scope, $element));
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/ReportFrame.js
// module id = 1765
// module chunks = 0